const Divider = ({ isDark }: { isDark?: boolean }) => (
  <div
    className={`hidden my-10 md:block border opacity-25 ${
      isDark ? 'border-grey' : 'border-white'
    }`}
  />
)

export default Divider
